/*
 * Description de collection repliable sur mobile (bannière « Texte à gauche, image à droite »).
 * Sous 1024 px, une description qui dépasse nettement le nombre de lignes choisi est coupée
 * en fondu, avec « Lire la suite ». Le texte complet reste dans la page, et sans script rien
 * n'est replié.
 */
if (typeof CollectionDescription !== "function") {
  class CollectionDescription extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector(".collection-split__description");
      this.button = this.querySelector(".collection-split__more");
      if (!this.text || !this.button) return;

      this.mobile = window.matchMedia("(max-width: 1023px)");
      this.width = 0;

      this.onToggle = () => this.toggle();
      this.onChange = () => this.measure();
      // Safari iOS signale un redimensionnement à chaque repli de la barre d'adresse :
      // seule la largeur change la coupe.
      this.onResize = () => {
        if (window.innerWidth !== this.width) this.measure();
      };
      this.button.addEventListener("click", this.onToggle);
      this.mobile.addEventListener("change", this.onChange);
      window.addEventListener("resize", this.onResize);

      this.measure();
      // Une promesse ne se désabonne pas : si l'élément a quitté la page entre-temps, on ne mesure rien.
      if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
    }

    disconnectedCallback() {
      if (!this.button) return;
      this.button.removeEventListener("click", this.onToggle);
      this.mobile.removeEventListener("change", this.onChange);
      window.removeEventListener("resize", this.onResize);
    }

    measure() {
      this.width = window.innerWidth;
      if (!this.mobile.matches) {
        this.setOpen(false);
        this.classList.remove("is-collapsed");
        this.button.hidden = true;
        return;
      }
      if (this.classList.contains("is-open")) return;

      // Mesure à plat : on retire la coupe le temps de comparer la hauteur réelle au plafond.
      this.classList.remove("is-collapsed");
      const style = getComputedStyle(this.text);
      let line = parseFloat(style.lineHeight);
      if (isNaN(line)) line = parseFloat(style.fontSize) * 1.5;
      const lines = parseInt(this.dataset.lines, 10) || 5;
      const limit = Math.round(line * lines);

      // Pas de coupe pour une ou deux lignes de trop : le lien prendrait autant de place.
      const collapsible = this.text.scrollHeight > limit + line * 2;
      this.style.setProperty("--description-max", `${limit}px`);
      this.classList.toggle("is-collapsed", collapsible);
      this.button.hidden = !collapsible;
    }

    setOpen(open) {
      this.classList.toggle("is-open", open);
      this.button.setAttribute("aria-expanded", open ? "true" : "false");
      this.button.textContent = open ? this.button.dataset.labelLess : this.button.dataset.labelMore;
    }

    toggle() {
      const open = !this.classList.contains("is-open");
      // En repliant, le lien reste sous le doigt au lieu de laisser la page sauter.
      const before = this.button.getBoundingClientRect().top;
      this.setOpen(open);
      this.classList.toggle("is-collapsed", !open);
      if (!open) window.scrollBy(0, this.button.getBoundingClientRect().top - before);
    }
  }

  customElements.define("collection-description", CollectionDescription);
}
